<template>
  <div>
    <common-dialog
      ref="dialog"
      width="300px"
      unit="终止"
      id-key="UserId"
      @close-saved="$emit('close-saved')"
      @closed="$emit('onClosed')"
      @details-opened="detailsOpened"
    >
        <template slot="form" >
          <el-form-item label="回退仓库">
            <el-select v-model="WarehouseId">
              <el-option
                v-for="item in warehouseList"
                :key="item.WarehouseId"
                :label="item.WarehouseName"
                :value="item.WarehouseId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回退数量">
            <el-input placeholder="请输入回退数量" v-model="Quantity" type="number" />
          </el-form-item>
        </template>

      <template slot="footer">
        <el-button type="primary" @click="save">确定</el-button>
        <el-button @click="close">关闭</el-button>
      </template>
    </common-dialog>
  
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },

  data() {
    return {
      warehouseApi: require("@/api/ba/warehouse").default,
      api: require("@/api/production/workDoc").default,
      WorkDocId: null,
      warehouseList: [],
      WarehouseId: null,
      Quantity: null,
      notQuantity: null, // 工单的未入库数 = 工单的需求数量 - 工单的累计入库数
    };
  },
  methods: {
    detailsOpened(data){
      console.log('data', data)

      this.warehouseApi.list({ WarehouseType: 2 }).then((res) => {
        if (res.Code === 0) {
          this.warehouseList = res.Data;
          this.warehouseList.unshift({
            WarehouseId: data.PickingWarehouseId,
            WarehouseName: data.PickingWarehouseName
          })
          this.WarehouseId = data.PickingWarehouseId;
          this.WorkDocId = data.WorkDocId;
          this.notQuantity = data.Quantity - data.InQuantity
          this.Quantity = null;
          console.log('this.warehouseList', this.warehouseList)
        }
      });
    },
    save(){

      this.Quantity = Number(this.Quantity)
      if(this.Quantity > this.notQuantity){
        this.$message.error(`回退数量不能大于未入库数量(${this.notQuantity})`)
        return
      }

      let o = {
        WarehouseId: this.WarehouseId,
        WorkDocId: this.WorkDocId,
        Quantity: this.Quantity,
      }
      this.api.close(o).then(res => {
        
        if(res.Code === 0){
          this.$message.success(res.Msg)
        }else{
          this.$message.warning(res.Msg)
        }
        this.$emit('saved')
        this.close()
      })
    },
    close(){
      this.WarehouseId = null;
      this.WorkDocId = null;
      this.warehouseList = [];
      this.Quantity = null;
      this.notQuantity = null;
      this.$refs.dialog.close(true)
    }
  }

};
</script>


